// extracted by mini-css-extract-plugin
export default {"ThemePreview":"ThemePreview_ThemePreview__YpgwQ","ColorsPreview":"ThemePreview_ColorsPreview__Wg5Gt","ColorPreview":"ThemePreview_ColorPreview__8-I+X"};